import ImmersivePortfolio from '@/components/immersive/ImmersivePortfolio'
import '@/styles/immersive.css'

export default function Index() {
  return <ImmersivePortfolio />
}
